export const getDevicesStale = (state, deviceType) => 
	!state.devices[deviceType]?.isFetching && !state.devices[deviceType]?.data;
